import { toast } from "react-toastify";
import { fetcheditUserRoleFailure, fetcheditUserRoleSuccess } from "./reducer";
import { setEditSuccessMessage } from "../../toastMessage/action";
import { ROLE } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";

export const editUserRole = (jsonObj, roleName, setLoading,navigate) => 
    async (dispatch) => {
        setLoading(true);
        try {
            const response = await determineBaseUrlAndPerformApiCall(
                `${ROLE}/${roleName}`,
                "PATCH",
                jsonObj
            );

            if (response.error) {
                dispatch(fetcheditUserRoleFailure(response.error.message));
                toast.error(response.error.message);
            } else {
                dispatch(fetcheditUserRoleSuccess(response));
                navigate("/userroles", { state: { successMessage: "User role updated successfully!" } });
            }
        } catch (error) {
            dispatch(fetcheditUserRoleFailure(error.message));
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };
